import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {TemplateAsset} from 'common/src/modules/dynamicParameters/dynamicParameters.types';
import {TemplateAssetType} from 'common/src/modules/dynamicParameters/dynamicParameters.enums';
import {TemplateFontsState} from './templateFonts.types';

export const templateFontsInitialState: TemplateFontsState = {
  templateAssets: [],
  droppedAssetsType: [],
};

const templateFontsReducer = createSlice({
  name: `${BreadcrumbName.CreativeTemplatePage}/templateFonts`,
  initialState: templateFontsInitialState,
  reducers: {
    resetState: () => templateFontsInitialState,

    setTemplateAssets: (state, action: PayloadAction<TemplateAsset[]>) => {
      state.templateAssets = action.payload;
    },

    addTemplateAssets: (state, action: PayloadAction<TemplateAsset[]>) => {
      state.templateAssets = [...state.templateAssets, ...action.payload];
    },

    upsertTemplateAsset: (state, action: PayloadAction<TemplateAsset>) => {
      const asset = action.payload;
      const exists = state.templateAssets.some(({id}) => id === asset.id);
      state.templateAssets = exists
        ? state.templateAssets.map((templateAsset) =>
            templateAsset.id === asset.id ? asset : templateAsset,
          )
        : [asset, ...state.templateAssets];
    },

    removeTemplateAssetById: (state, action: PayloadAction<number | string>) => {
      const id = action.payload;
      state.templateAssets = state.templateAssets.filter((asset) => asset.id !== id);
    },

    setDroppedAssetsType: (state, action: PayloadAction<TemplateAssetType[]>) => {
      state.droppedAssetsType = action.payload;
    },

    removeDroppedAssetType: (state, action: PayloadAction<TemplateAssetType>) => {
      const index = state.droppedAssetsType.indexOf(action.payload);

      if (index >= 0) {
        state.droppedAssetsType = state.droppedAssetsType.filter((_, i) => i !== index);
      }
    },
  },
});

export const {
  resetState,
  setTemplateAssets,
  addTemplateAssets,
  upsertTemplateAsset,
  removeTemplateAssetById,
  setDroppedAssetsType,
  removeDroppedAssetType,
} = templateFontsReducer.actions;

export default templateFontsReducer.reducer;

